export const TEPROSIF_ITEMS = [
  {
    "id": 1,
    "label": "Plancha",
    "key": "Plancha",
    "syllables": 2
  },
  {
    "id": 2,
    "label": "Rueda",
    "key": "Rueda",
    "syllables": 2
  },
  {
    "id": 3,
    "label": "Mariposa",
    "key": "Mariposa",
    "syllables": 4
  },
  {
    "id": 4,
    "label": "Bicicleta",
    "key": "Bicicleta",
    "syllables": 4
  },
  {
    "id": 5,
    "label": "Helicóptero",
    "key": "Helicoptero",
    "syllables": 4
  },
  {
    "id": 6,
    "label": "Bufanda",
    "key": "Bufanda",
    "syllables": 3
  },
  {
    "id": 7,
    "label": "Caperucita",
    "key": "Caperucita",
    "syllables": 5
  },
  {
    "id": 8,
    "label": "Alfombra",
    "key": "Alfombra",
    "syllables": 3
  },
  {
    "id": 9,
    "label": "Refrigerador",
    "key": "Refrigerador",
    "syllables": 5
  },
  {
    "id": 10,
    "label": "Edificio",
    "key": "Edificio",
    "syllables": 4
  },
  {
    "id": 11,
    "label": "Calcetín",
    "key": "Calcetin",
    "syllables": 3
  },
  {
    "id": 12,
    "label": "Dinosaurio",
    "key": "Dinosaurio",
    "syllables": 5
  },
  {
    "id": 13,
    "label": "Teléfono",
    "key": "Telefono",
    "syllables": 3
  },
  {
    "id": 14,
    "label": "Remedio",
    "key": "Remedio",
    "syllables": 3
  },
  {
    "id": 15,
    "label": "Peineta",
    "key": "Peineta",
    "syllables": 3
  },
  {
    "id": 16,
    "label": "Auto",
    "key": "Auto",
    "syllables": 2
  },
  {
    "id": 17,
    "label": "Indio",
    "key": "Indio",
    "syllables": 3
  },
  {
    "id": 18,
    "label": "Pantalón",
    "key": "Pantalon",
    "syllables": 3
  },
  {
    "id": 19,
    "label": "Camión",
    "key": "Camion",
    "syllables": 3
  },
  {
    "id": 20,
    "label": "Cuaderno",
    "key": "Cuaderno",
    "syllables": 3
  },
  {
    "id": 21,
    "label": "Micro",
    "key": "Micro",
    "syllables": 2
  },
  {
    "id": 22,
    "label": "Tren",
    "key": "Tren",
    "syllables": 1
  },
  {
    "id": 23,
    "label": "Plátano",
    "key": "Platano",
    "syllables": 3
  },
  {
    "id": 24,
    "label": "Jugo",
    "key": "Jugo",
    "syllables": 2
  },
  {
    "id": 25,
    "label": "Enchufe",
    "key": "Enchufe",
    "syllables": 3
  },
  {
    "id": 26,
    "label": "Jabón",
    "key": "Jabon",
    "syllables": 2
  },
  {
    "id": 27,
    "label": "Tambor",
    "key": "Tambor",
    "syllables": 2
  },
  {
    "id": 28,
    "label": "Volantín",
    "key": "Volantin",
    "syllables": 3
  },
  {
    "id": 29,
    "label": "Jirafa",
    "key": "Jirafa",
    "syllables": 3
  },
  {
    "id": 30,
    "label": "Gorro",
    "key": "Gorro",
    "syllables": 2
  },
  {
    "id": 31,
    "label": "Árbol",
    "key": "Arbol",
    "syllables": 2
  },
  {
    "id": 32,
    "label": "Dulce",
    "key": "Dulce",
    "syllables": 2
  },
  {
    "id": 33,
    "label": "Guitarra",
    "key": "Guitarra",
    "syllables": 3
  },
  {
    "id": 34,
    "label": "Guante",
    "key": "Guante",
    "syllables": 2
  },
  {
    "id": 35,
    "label": "Reloj",
    "key": "Reloj",
    "syllables": 2
  },
  {
    "id": 36,
    "label": "Jaula",
    "key": "Jaula",
    "syllables": 2
  },
  {
    "id": 37,
    "label": "Puente",
    "key": "Puente",
    "syllables": 2
  }
];
